<template>
  <LoginComponent />
</template>

<script>
import LoginComponent from '@/components/auth/LoginComponent.vue';

export default {
  name: 'LoginView',
  components: {
    LoginComponent,
  },
  mounted() {
    window.scrollTo(0, 0);
    },
}
</script>

<style scoped>

</style>
